<template>
    <div class="fill-height pt-2" :class="{ 'd-flex align-center justify-center': loading }">
		<div v-if="loading" class="d-flex justify-center align-center" style=" height: 100% ">
			<div>
				<div 
					:class="{
						'loader': !$vuetify.theme.dark,
						'loader-dark': $vuetify.theme.dark
					}" 
				></div>
			</div>
		</div>
	
		<template v-else>
			<!-- header card -->
			<Transition name="slide-fade">
				<v-card 
					v-if="!checkIn && !$route.params.id" 
					class="card-style rounded-lg"
					:class="{
						'bg-secondary': !$vuetify.theme.dark,
						'grey darken-3': $vuetify.theme.dark,
						'h-good-morning-card-lgAndUp': $vuetify.breakpoint.lgAndUp,
						'h-good-morning-card-mdAndDown': $vuetify.breakpoint.mdAndDown 
					}"
				>
					<v-card-text class="pt-0 mt-2">
						<v-row align="center" class="ps-4">
							<v-col
								:cols="$vuetify.breakpoint.lgAndUp ? 'auto' : '2'"
								class="px-0 py-0"
								:align-self="$vuetify.breakpoint.lgAndUp ? 'start' : 'end'"
								style="height: 60px"
							>
								<v-img 
									v-if="!$vuetify.theme.dark"
									:src="photo" 
									width="150" 
									height="73"  
									contain 
									class=" mt-2" 
								/>
								<v-img 
									v-else
									:src="photo" 
									width="150" 
									height="70"  
									contain 
									class=" mt-2" 
								/>
							</v-col>
							<v-col :cols="$vuetify.breakpoint.lgAndUp ? '4' : '9'" align-self="center" class="px-0">
								<h2 class="primary--text mb-1"> Have A Great Day {{self.name}} </h2>
								<span class="Righteous-font">Full of Productivity and Good Vibes</span>
							</v-col>

							<v-col class="d-flex justify-end py-0 pe-0 mt-0 mr-minus ">
								<v-btn
									@click="createWorkDay()"
									small
									color="primary"
									height="80"
									width="100"
									elevation="0"
									class="text-none rounded-r-lg"
									:loading="loading"
									:disabled="workDays.find(c => moment(c.date).isSame(moment(), 'day')) ? workDays.find(c => moment(c.date).isSame(moment(), 'day')).endDate !== null : false"
								>
									<div class="d-flex flex-column align-center">
										<v-img src="../../assets/Vectors/whiteFingerprint.svg" width="30px" />
										<span class="pt-2"> Check in  </span>
									</div>
								</v-btn>
							</v-col>    
						</v-row>
					</v-card-text>
				</v-card>
			</Transition>
			
			<Transition name="slide-fade">
				<card-task
					v-if="$route.params.id"
					:date="today.date"
					:start="today.startDate"
					:end="today.endDate"
					:partTime="partTime"
					:isCheckInToday="true"
					:workDayId="$route.params.id"
				>
				</card-task>
			</Transition>
			<!-- list -->
			<div v-if="workDays.length !== 0" class="pt-4">
				<v-row>
					<v-col>
						<h4 class="mb-1 Urbanist-font">Last Timesheet</h4>  
					</v-col>

					<!-- filter -->
					<v-col cols="4" align-self="center" class="text-center py-1">
						<v-row class="d-flex justify-center">
							<v-col cols="auto" class="px-0">
								<a @click="subtractWeek()">
									<v-img
										src="../../assets/Vectors/Group 9.png"
										contain
										width="25"
									/>
								</a>
							</v-col>
							<v-col cols="5" class="px-0">
								<span class="fw-4 fs-sm text--color fs-12">
									{{ moment(startDate).format('ll') + ' - ' + moment(endDate).format('ll')}} 
								</span>
						
							</v-col>
							<v-col v-if="!moment(endDate).isAfter(moment(), 'day')" cols="auto" class="px-0">
								<a @click="addWeek()">
									<v-img
										src="../../assets/Vectors/Group 9.png"
										contain
										width="25"
										class="reverse-icon"
									/>
								</a>
							</v-col>
						</v-row>
					</v-col>
					<v-spacer />
				</v-row>
	
				<!-- cards -->
				<template v-if="!progressLoading">
					<div
						v-for="
							(task, i) in workDays.filter((c) => (( moment(c.date).isSame(moment(), 'day')  && c.endDate !== null) ) 
							|| (!moment(c.date).isSame(moment(), 'day')))
						" 
						:key="i" 
					>
						<card-task
							:date="task.date"
							:start="task.startDate"
							:end="task.endDate"
							:partTime="task.partTime"
							:workDayId="task.id"
							:actualWorkTime="((task.actualWorkTime) / 60)"
						>
						</card-task>
					</div>
				</template>
			</div>
		</template>
		<div v-if="progressLoading" class="progressLoadingStyle" > Loading ... </div>
    </div>
</template>

<script>
import CardTask from '@/components/CardTask.vue'
import moment from 'moment'
import { mapState } from 'vuex'
export default {
	components: {
		CardTask
	},

	data () {
		return {
			loading: false,
			checkIn: false,
			partTime: null,

			// for storage
			workDayData: { startTime: null, endTime: null, date: null },
			today: {},
			workDays: {},
			photos: [
				require('../../assets/New folder/GoodAfternoon.png'),
				require('../../assets/New folder/goodEvening.png'),
				require('../../assets/Vectors/GoodMoring.svg'),
				require('../../assets/New folder/GoodDay.png')
			],
			startDate: moment(moment().startOf('week')).subtract(1, 'day'),
			endDate: null,
			progressLoading: false
		}
	},

	computed: {
		...mapState({
			// workDays: state => state.workDay?.workDays?.reverse(),
			userId: state => state.auth.self.id,
			// myData: state => state.users.myData
			self: state => state.auth.self
		}),

		photo () {
			let index = 0
			if (moment().isSameOrAfter(moment().format('YYYY-MM-DD') + 'T12:00:00', 'time')) {
				console.log('1')
				index = 0
			} else if ((moment().isBefore(moment().format('YYYY-MM-DD') + 'T12:00:00'))) {
				console.log('2')
				// good morning
				index = 2
			} else if ((moment().isSameOrAfter(moment().format('YYYY-MM-DD') + 'T4:00:00'))) {
				console.log('4')
				index = 1
			}
			return this.photos[index]
		}
	},

	methods: {
		moment,
		createWorkDay () {
			this.loading = true
			this.$store.dispatch('workDay/create', { 
				date: this.moment().format('YYYY-MM-DD'), 
				startDate: this.moment().format().split('+')[0],
				endDate: null,
				enterTime: null, 
				leaveTime: null, 
				userId: this.userId, 
				taskIds: [],
				notes: ''
			}).then((data) => {
				this.getWorkDayById(data)
				this.workDayId = data;
				this.checkIn = true
				this.today.id = data
				this.$router.replace({
					params: {
						id: data
					}
				})
			}).finally(() => {
				this.loading = false
			})
		},

		getWorkDayById (id) {
			this.$store.dispatch('workDay/fetchById', { id: id }).then((data) => {
				this.today = data
			})
		},

		addWeek () {
			this.startDate = moment(this.startDate).add(7, 'days')
			this.endDate = moment(this.startDate).add(5, 'days')
			this.getTaskSelfByDate()
		},

		subtractWeek () {
			this.startDate = moment(this.startDate).subtract(7, 'days')
			this.endDate = moment(this.startDate).add(5, 'days')
			this.getTaskSelfByDate()
		},

		getTaskSelfByDate () {
			this.progressLoading = true
			this.$store.dispatch('workDay/fetchSelf', { 
				fromDate: moment(this.startDate).format('YYYY-MM-DD'), 
				toDate: moment(this.endDate).format('YYYY-MM-DD')
			}).then((data) => {
				this.workDays = data?.reverse()
			}).finally(() => {
				this.progressLoading = false
			})
		}
	},

	created () {
		this.endDate = this.moment(this.startDate).add(5, 'day')
		this.loading = true
		// show last seven day task
		this.$store.dispatch('workDay/fetchSelf', { 
			fromDate: moment(moment(moment().startOf('week')).subtract(1, 'day')).format('YYYY-MM-DD'), 
			toDate: moment(moment().endOf('week')).format('YYYY-MM-DD')
		}).then((data) => {
			this.workDays = data?.reverse()
			if (
				!this.$route.params.id && data.find(c => moment(c.date).isSame(moment().format('YYYY-MM-DD'), 'day')) && data.find(c => moment(c.date).isSame(moment(), 'day')).endDate === null
			) {
				this.$router.replace({
					params: {
						id: data.find(c => moment(c.date).isSame(moment(), 'day'))?.id
					}
				})
				this.getWorkDayById(this.$route.params.id)
			} else if (
				data.find(c => moment(c.date).isSame(moment(), 'day')) && data.find(c => moment(c.date).isSame(moment(), 'day'))?.endDate !== null
			) {
				this.checkIn = false
				// this.$router.replace({
				// 	name: 'all-tasks'
				// })
				// this.getWorkDayById(this.$route.params.id)
			} else if (data.length === 0) {
				this.checkIn = false
			}
			if (this.$route.params.id) {
				this.getWorkDayById(this.$route.params.id)
			}
		}).finally(() => {
			this.loading = false
		})
	}
}
</script>

<style>
body {
    color: black;
}

.card-style {
	width: 100%;
	height: 80px;
}
.bg-secondary {
	background-color: #FBF4DA !important;
	box-shadow: none !important;
}
.bg-white {
	background-color: white;
}

/* .mt-minus {
	margin-top: 0px;
} */
.mr-minus {
	margin-right: -4px;
}
.slide-fade-enter-active {
  transition: all 0.9s ease-out;
}

.slide-fade-leave-active {
  transition: all 0.3s cubic-bezier(1, 0.5, 0.8, 1);
}

.slide-fade-enter-from,
.slide-fade-leave-to {
  transform: translateX(20px);
  opacity: 0;
}
.h-good-morning-card-lgAndUp {
	height: 80px;
}
.h-good-morning-card-mdAndDown {
	height: 120px;
}
.progressLoadingStyle {
	width: 100%;
    height: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
}
</style>
